import * as React from "react";
import Svg, { SvgProps, Path, Circle } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={24} height={24} fill="none" {...props}>
    <Path
      fill="#000"
      d="M11.546 21.316v-1.415c-2.071-.192-3.774-.954-5.108-2.288-1.335-1.335-2.097-3.037-2.288-5.109H2.734v-.923H4.15c.19-2.07.953-3.771 2.288-5.1 1.334-1.33 3.037-2.09 5.108-2.28V2.785h.923v1.416c2.071.19 3.771.95 5.1 2.28 1.33 1.329 2.09 3.03 2.28 5.1h1.416v.923H19.85c-.191 2.072-.951 3.774-2.28 5.109-1.33 1.334-3.03 2.096-5.101 2.288v1.415h-.923Zm.47-2.327c1.921 0 3.555-.679 4.902-2.036s2.02-2.997 2.02-4.918c0-1.922-.673-3.556-2.02-4.903-1.347-1.346-2.98-2.02-4.902-2.02-1.922 0-3.561.673-4.919 2.02-1.357 1.347-2.036 2.981-2.036 4.903 0 1.921.679 3.56 2.036 4.918 1.358 1.357 2.997 2.036 4.919 2.036Z"
    />
    <Circle cx={12} cy={12} r={4} fill="#000" />
  </Svg>
);
export default SvgComponent;
